import professionTabsChangeButtonClick from '@hh.ru/analytics-js-events/build/career_platform/profession/profession_tabs_change_button_click';
import { translation, useSelector, TranslatedComponent } from '@hh.ru/front-static-app';
import { Tab, Tabs } from '@hh.ru/magritte-ui';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';
import { SPALink } from '@hh.ru/redux-spa-middleware';

import { getCurrentRouteHrefWithParam } from 'src/app/routesUtils';
import { CurrentSectionState } from 'src/models/pages/profession';
import { analytics, Goal } from 'src/utils/analytics';

const TrlKeys = {
    info: 'career-platform.profession.nav.info',
    calculator: 'career-platform.profession.nav.calculator',
    courses: 'career-platform.profession.nav.courses',
    careerTrack: 'career-platform.profession.nav.careerTrack',
};

interface NavItem {
    id: CurrentSectionState;
    name: string;
    onSendAnalytics: () => void;
}

interface Props {
    onChange: () => void;
}

const navItems: NavItem[] = [
    {
        id: CurrentSectionState.STATISTIC,
        name: TrlKeys.info,
        onSendAnalytics: () => {
            professionTabsChangeButtonClick({ buttonName: 'salary_vacancy_dynamics' });
            analytics.reach(Goal.click_profession_guide_tab_salary_vacancies);
        },
    },
    {
        id: CurrentSectionState.CAREERTRACK,
        name: TrlKeys.careerTrack,
        onSendAnalytics: () => {
            professionTabsChangeButtonClick({ buttonName: 'career_track' });

            analytics.reach(Goal.click_profession_guide_tab_career_track);
        },
    },
    {
        id: CurrentSectionState.CALCULATOR,
        name: TrlKeys.calculator,
        onSendAnalytics: () => {
            professionTabsChangeButtonClick({ buttonName: 'calculator' });
            analytics.reach(Goal.click_profession_guide_tab_calculator);
        },
    },
    {
        id: CurrentSectionState.COURSES,
        name: TrlKeys.courses,
        onSendAnalytics: () => {
            professionTabsChangeButtonClick({ buttonName: 'courses' });
            analytics.reach(Goal.click_profession_guide_tab_courses);
        },
    },
];

const NavSections: TranslatedComponent<Props> = ({ onChange, trls }) => {
    const currentSection = useSelectorNonNullable((state) => state.pageProfession.currentSection);
    const location = useSelector((state) => state.router.location);

    const onChangeSection = ({ onSendAnalytics }: NavItem) => {
        onSendAnalytics();
        onChange();
    };

    return (
        <Tabs activeItemId={currentSection} mode="secondary">
            {navItems.map((item) => (
                <Tab
                    key={item.id}
                    id={item.id}
                    Element={SPALink}
                    to={getCurrentRouteHrefWithParam(location, 'section', item.id)}
                    isSeoLink
                    onClick={() => onChangeSection(item)}
                    cancelScrollCorrection
                    data-qa={`page-nav-${item.id}`}
                >
                    {trls[item.name]}
                </Tab>
            ))}
        </Tabs>
    );
};

export default translation(NavSections);
